export default __webpack_public_path__ + "static/media/fonendo.243658dc.png";